import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=54f8ebc6"
import script from "./Localization.vue?vue&type=script&lang=js"
export * from "./Localization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54f8ebc6')) {
      api.createRecord('54f8ebc6', component.options)
    } else {
      api.reload('54f8ebc6', component.options)
    }
    module.hot.accept("./Localization.vue?vue&type=template&id=54f8ebc6", function () {
      api.rerender('54f8ebc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemManage/Localization.vue"
export default component.exports